import classNames from "classnames"
import { Observer } from "mobx-react"
import React from "react"
import { Link } from "react-router-dom"

import appApi from "@/api/app"
import { DiscountModule } from "@/component/ImageBanner/DiscountModule"
import { MarketingPicture } from "@/component/ImageBanner/MarketingPicture"
import stores from "@/stores"

import styles from "./index.module.scss"

interface MarketingChangePlanProps {
  children?: React.ReactNode
  showFreeQuota?: boolean
}
const MarketingChangePlan = ({ children, showFreeQuota }:MarketingChangePlanProps) => {
  const { userInfoSore } = stores

  return <Observer>{() => {
    const { banner_discount_v2024_04 } = userInfoSore.data

    return <div className={classNames("relative", styles.relativeWrapper)}>
      <MarketingPicture
        show
        src={showFreeQuota ? banner_discount_v2024_04.with_double_quota_tip_banner_url : banner_discount_v2024_04.main_banner_url}
        onClose={() => {
          appApi.dispatchMarketingBanner("dashboard")
            .then(({ data }) => {
              userInfoSore.setDataSingle("banner_discount_v2024_04", {
                ...banner_discount_v2024_04,
                ...data.banner_discount_v2024_04,
              })
            })
        }}
        to={"/billing/plans"}
        minHeight={showFreeQuota ? "large" : "medium"}
      >
        <Link to={"/billing/plans"}>
          <DiscountModule classNames={"pointer-cursor"} titleVariant={"headingXl"} />
        </Link>
      </MarketingPicture>
      <div className={"absolute bottom-4 md:bottom-5 left-4 right-4"}>{children}</div>
    </div>
  }}</Observer>
}

export default MarketingChangePlan
